import React from "react";
import { Flame } from "lucide-react";

const GiveCancel = () => (
  <div className="min-h-screen flex items-center justify-center ember-bg px-6">
    <div className="bento-card !p-10 max-w-lg w-full text-center" data-testid="give-cancel">
      <span className="glow-blob" />
      <div className="icon-badge !h-14 !w-14 mx-auto mb-6">
        <Flame className="h-7 w-7 text-[#F28C18]" strokeWidth={1.5} />
      </div>
      <h1 className="font-serif-display text-4xl text-[#F6F0E6]">Gift not completed</h1>
      <p className="mt-3 text-[#D9D9D9]">No worries — your card was not charged. You can try again any time.</p>
      <div className="mt-8 flex gap-3 justify-center">
        <a href="/#give" className="btn-fire">Return to Giving</a>
        <a href="/" className="btn-ghost">Home</a>
      </div>
    </div>
  </div>
);

export default GiveCancel;
